export default __webpack_public_path__ + "static/media/phonegap.a9e2d1e3.svg";